// Importing project component.
import { ProjectPage as Project } from "../components/Project";

// Page: Ludi project page.
export default function Ludi() {
  const images = [
    require("../images/ludi/home-page.webp"),
    require("../images/ludi/home-explore-section.webp"),
    require("../images/ludi/search-page.webp"),
    require("../images/ludi/game-page.webp"),
    require("../images/ludi/game-info-section.webp"),
  ];

  return (
    <div>
      <Project
        img={images}
        title="Ludi"
        desc={
          "Ludi is a game discovery and personal-library app that brings metadata, pricing, and your own collection into a single interface. I started the design in Figma to lock down layout, visual language, and design tokens before writing any code, then built the app on Next.js 16 (App Router) with React 19 and TypeScript. The UI is styled with Tailwind CSS v4 using a custom design-token system, with shadcn/ui and Radix primitives for accessible dialogs, dropdowns, and forms, dnd-kit for drag-and-drop list reordering, and Framer Motion for interface animation.\n\nData comes from two external sources — IGDB for game metadata and IsThereAnyDeal for pricing and deals — proxied through server-only Next.js route handlers and Server Actions so API keys never reach the client. User accounts, profiles, ratings, and lists are stored in Supabase (Postgres) with Row Level Security enforcing per-user data access, and Supabase Auth handles session management via middleware-based route protection.\n\nThis is a rebuild of an earlier MERN-stack (MongoDB, Express, React, Node.js) version of the project, redone with a modern React Server Components architecture, a proper design system, and a managed Postgres backend in place of a hand-rolled Express API."
        }
        btn1={"https://ludi-m3.vercel.app/"}
        btn1Text={"See App"}
        btn2={"https://github.com/EnriqueSaracho/ludi-m3"}
        btn2Text={"See Code"}
        btn3={"https://www.figma.com/design/HIrybWq1i0qI9PbZlTOCfI/Ludi-M2?node-id=0-1&p=f&t=aW731j3G2mjzi1db-0"}
        btn3Text={"See Design"}
        field="Full-Stack Web development"
        skills={["Next.js", "React", "TypeScript", "Tailwind CSS", "Supabase", "Figma"]}
      />
    </div>
  );
}
